import { ErrorComponent } from "components";

const ErrorComponentAdapter = () => <ErrorComponent text="The component has not been created yet." />;

export default ErrorComponentAdapter;
